module.exports = __webpack_public_path__ + "media/logos/buildout-icon-only-latest-89d95958.svg";